const CHARACTER_LIMIT = 255;

export const constants = {
  CHARACTER_LIMIT
};
